import React from 'react';
import { FadeInSection } from './ui/FadeInSection';
import { CTAButton } from './ui/CTAButton';
import { Star } from 'lucide-react';
export function HeroAndUrgency() {
  return <>
      {/* SECTION 2 — URGENCY BAR (fixed at top, always visible) */}
      <section className="bg-urgency text-white py-3 px-4 fixed top-0 left-0 right-0 z-50 shadow-lg" data-id="element-53">
        <div className="max-w-3xl mx-auto text-center" data-id="element-54">
          <p className="font-bold text-sm md:text-base flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2" data-id="element-55">
            <span data-id="element-56">🔥 PRECIO DE LANZAMIENTO ACTIVO —</span>
            <span className="font-normal" data-id="element-57">
              Esta oferta no estará disponible a este precio por mucho tiempo
              más.
            </span>
          </p>
        </div>
      </section>

      {/* SECTION 1 — HERO */}
      <section className="bg-chocolate text-warmWhite px-4 pt-24 pb-16 md:pt-28 md:pb-24 relative overflow-hidden" data-id="element-58">
        {/* Subtle background glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-lg h-96 bg-gold/10 blur-3xl rounded-full pointer-events-none" data-id="element-59"></div>

        <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-60">
          <FadeInSection data-id="element-61">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-gold leading-[1.1] mb-8" data-id="element-62">
              Controlá tu ansiedad por el dulce
              <br className="hidden md:block" data-id="element-63" /> en 21 días...
              <br data-id="element-64" />
              <span className="text-warmWhite font-bold text-4xl md:text-5xl lg:text-6xl mt-3 block leading-tight" data-id="element-65">
                comiendo alfajores, helado
                <br className="hidden md:block" data-id="element-66" /> y chocolate todos los días.
              </span>
            </h1>
          </FadeInSection>

          <FadeInSection delay={200} className="w-full max-w-md mx-auto mb-10" data-id="element-67">
            <img src="https://cdn.magicpatterns.com/uploads/vVtmQXAzTB3twVeUuMKgza/Mockup.png" alt="Método Antídoto Dulce Mockup" className="w-full h-auto drop-shadow-2xl" data-id="element-68" />
          </FadeInSection>

          <FadeInSection delay={300} className="max-w-2xl mx-auto mb-10" data-id="element-69">
            <p className="text-xl md:text-2xl text-cream mb-6 font-medium" data-id="element-70">
              El sistema proteico que hackea el mecanismo del antojo y convierte
              el dulce en tu mejor aliado.
            </p>
            <p className="text-lg md:text-xl text-gold-light font-semibold" data-id="element-71">
              Sin dietas. Sin privaciones.
              <br data-id="element-72" />
              Sin empezar de nuevo el lunes.
            </p>
          </FadeInSection>

          <FadeInSection delay={400} className="w-full flex flex-col items-center" data-id="element-73">
            <CTAButton className="w-full md:w-auto text-xl px-10 py-5 mb-6" data-id="element-74">
              🔥 QUIERO EL SISTEMA COMPLETO
            </CTAButton>

            <div className="flex flex-col items-center gap-2" data-id="element-75">
              <div className="flex gap-1" data-id="element-76">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-77" />)}
              </div>
              <p className="text-sm md:text-base text-cream/80 font-medium" data-id="element-78">
                +500 mujeres argentinas ya transformaron su relación con el
                dulce.
              </p>
            </div>
          </FadeInSection>
        </div>
      </section>

      {/* SECTION 3 — HEADLINE */}
      <section className="bg-cream px-4 py-16 md:py-24" data-id="element-79">
        <div className="max-w-3xl mx-auto text-center" data-id="element-80">
          <FadeInSection data-id="element-81">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-chocolate mb-8 leading-tight" data-id="element-82">
              ¿Y si el problema nunca fue el dulce...
              <br data-id="element-83" />
              <span className="text-chocolate-light italic font-normal" data-id="element-84">
                sino que nadie te enseñó a comerlo bien?
              </span>
            </h2>
            <div className="w-24 h-1 bg-gold mx-auto mb-8 rounded-full" data-id="element-85"></div>
            <p className="text-lg md:text-xl text-textBody leading-relaxed max-w-2xl mx-auto" data-id="element-86">
              Mujeres argentinas que comen chocolate y alfajores todos los días
              y aun así se sienten bien en su cuerpo.
              <br data-id="element-87" />
              <br data-id="element-88" />
              <strong className="text-chocolate" data-id="element-89">
                Esto es lo que hacen diferente.
              </strong>
            </p>
          </FadeInSection>
        </div>
      </section>
    </>;
}